import { render, staticRenderFns } from "./ChoicesValuesAiView.vue?vue&type=template&id=3d919e76&scoped=true&"
import script from "./ChoicesValuesAiView.vue?vue&type=script&lang=ts&"
export * from "./ChoicesValuesAiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d919e76",
  null
  
)

export default component.exports